import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-localize-redux";
import { getIcon } from "../utils/ui";

const Format = ({ code, url }) => {
  const content = (
    <>
      <span className={"icon " + getIcon(code)} aria-hidden="true" />
      <Translate
        id={"format." + code}
        options={{
          onMissingTranslation: () => code
        }}
      />
    </>
  );

  return (
    <li>
      {url ? (
        <a
          href={url}
          className="btnlink btnlink--format"
          target="_blank"
          rel="noopener noreferrer"
        >
          {content}
        </a>
      ) : (
        <div className="btnlink btnlink--format btnlink--disabled">
          {content}
        </div>
      )}
    </li>
  );
};

Format.propTypes = {
  code: PropTypes.string.isRequired,
  url: PropTypes.string
};

export default Format;
